export * from '@fhs/routing/src/routes/(drawer)/support/index';
export { default } from '@fhs/routing/src/routes/(drawer)/support/index';
